/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { NavigationBehaviorOptions, NavigationExtras, Router, UrlTree } from '@angular/router';
import { from as observableFrom, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * Example of using this service:
 *  this.navigationService.navigate(['/some-route'], {
      queryParams: { session: '123' },
      fragment: 'anchor'
    }).subscribe({
      next: success => console.log('Navigation success:', success),
      error: error => console.log('Navigation error:', error)
    });
 */

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  public isLocked = false;
  private programmaticNavigationValue = false;

  private router = inject(Router);

  public get programmaticNavigation(): boolean {
    return this.programmaticNavigationValue;
  }

  public set programmaticNavigation(value: boolean) {
    this.programmaticNavigationValue = value;
  }

  public navigate(commands: any[], extras?: NavigationExtras, clearQueryParams?: boolean): Observable<boolean> {
    this.programmaticNavigation = true;
    const options: NavigationExtras = { ...extras, queryParamsHandling: clearQueryParams ? '' : 'merge' };
    return observableFrom(this.router.navigate(commands, options)).pipe(
      finalize(() => (this.programmaticNavigation = false))
    );
  }

  public navigateByUrl(url: string | UrlTree, extras?: NavigationBehaviorOptions): Observable<boolean> {
    this.programmaticNavigation = true;
    const navigateUrl = `${url}${location.search}`;

    return observableFrom(this.router.navigateByUrl(navigateUrl, extras)).pipe(
      finalize(() => (this.programmaticNavigation = false))
    );
  }

  public navigateToStart(): void {
    const regexText = /(QuoteId|QuoteID|quoteId|quoteID)=[^&]*/i;
    document.location.href = `/existing${location.search.replace(regexText, '')}`;
  }
}
